import { evt_AppReady } from '../react/constants/custom-event-names';
import { createTimelineEditor } from './timeline-editor';
import { getSequence, events } from '../state/global-state';
import { timeline } from '../state/timeline-state';
import { cameraProps } from '../state/camera-state';
import { isCameraRealignmentInProgress } from '../camera/camera-interface';

const preUpdate = (elapsedTime: number) => {
  isCameraRealignmentInProgress(elapsedTime);
};

const postUpdate = (elapsedTime: number) => {};

/**
 * Fügt einen EventListener hinzu, der auf ein benutzerdefinierte Signal lauscht,
 * dass darüber informieren soll, dass Verge3D fertig geladen wurde und die erste
 * Szene zu sehen ist.
 * Man braucht sich übrigens keine darüber Sorgen machen, dass ein mehrfacher Import
 * dieser Datei zu mehreren Listenern führen könnte!
 */
window.addEventListener(evt_AppReady, (e: CustomEventInit) => {
  const { app }: Verge.Data = e.detail;
  const { setCurrentTime } = createTimelineEditor(getSequence);
  let targetReached = false;

  /**
   * Lokale Fkt. die gelegentlich Einfluss auf den aktuellen Zeitpunkt der Timeline nimmt.
   * In der Regel beginnt sie ihre Arbeit, beim Drücken des Play Buttons oder bei Spulvorgängen.
   * Indirekt wirkt sich sich also auch auf den Animationsfortschritt aus.
   * @param elapsedTime Zeit in Sekunden die seit dem letzten MainLoop Zyklus,
   * also Frame, vergangen ist.
   */
  const updateAnimation = (elapsedTime: number) => {
    const { isPlaying, currentTime, speed, targetTime } = timeline;

    preUpdate(elapsedTime);

    if (cameraProps.realignmentInProgress) {
      return;
    }

    if (isPlaying) {
      if (speed === 0) {
        events.finishWindingOperation();
        return;
      }
      const step = elapsedTime * speed;
      let time = currentTime + step;

      /*
       * Sicherung, dass beim Spulen die Zeit nicht über das Ziel hinaus springt.
       * Gründe dafür sind Ungenauigkeiten, sowohl innerhalb von setTimeout() und setInterval(),
       * als auch in der Behandlung von gebrochenen Zahlen in Javascript im Allgemeinen.
       */
      if (
        (speed > 0 && time >= targetTime) ||
        (speed < 0 && time <= targetTime)
      ) {
        time = targetTime;
        targetReached = true;
      } else {
        targetReached = false;
      }

      setCurrentTime(time);

      /**
       * Wenn das Ziel des aktuellen Spulvorganges oder aber das Ende des Abspielvorganges erreicht wurde,
       * so informiere den globalen Zustand darüber.
       * Achtung: Diese Operation kann Einfluss auf einen Endlos-Abspielvorgang haben.
       */
      if (targetReached) {
        events.finishWindingOperation();
      }
    }

    postUpdate(elapsedTime);
  };

  /*
   * Einer unserer eigenen Verge3D Puzzle Bausteine ruft in jedem Update Zyklus
   * die Funktion onEveryRenderingFrame auf. Diese wird hier überladen, um
   * stattdessen die Anweisungen von updateAnimation auszulösen.
   */
  app.ExternalInterface.onEveryRenderingFrame = updateAnimation;
});
